import { createSelector } from '@reduxjs/toolkit';
export const selectBoilerModels = createSelector((state) => state.boiler_models.data, (boiler_data) => {
    if (boiler_data == null) {
        return { boiler_types: [], boiler_models: [] };
    }
    return boiler_data;
});
